import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/Cardeck-is-full.svg'
import _imports_1 from '@/assets/car-available.svg'


const _hoisted_1 = { class: "calendar-legend" }
const _hoisted_2 = {
  key: 0,
  class: "info"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "icons"
}
const _hoisted_5 = {
  key: 0,
  class: "icon"
}
const _hoisted_6 = {
  key: 1,
  class: "icon"
}

import { dateFormat } from "@/helpers/dateHelpers";
import { AvailabilityDate, monthChangeEvent } from "@/modules/AvailabilityCalendar/models/AvailabilityDate";
import { VCalendar, VModal } from "v-ferry-components";
import { ref } from "vue";
import { Attribute } from "../models/AvailabilityCalendarTypes";
import DateAvailability from "./DateAvailability.vue";

interface Props {
    attributes?: AvailabilityDate[];
    hasVehicle?: boolean;
    hasCabin?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AvailabilityCalendar',
  props: {
    attributes: {},
    hasVehicle: { type: Boolean },
    hasCabin: { type: Boolean }
  },
  emits: ["dateChange"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const calendarDate = ref<monthChangeEvent>();

const isDisabled = (attr: Attribute) => {
    return attr.key === "disabled";
};

const monthChange = (newDate: monthChangeEvent[]) => {
    const selectedMonth = newDate[0];
    const isDuplicateEvent = calendarDate.value?.month === selectedMonth.month && calendarDate.value?.year === selectedMonth.year;

    if (!isDuplicateEvent) {
        calendarDate.value = selectedMonth;
        emit("dateChange", selectedMonth);
    }
};

const dateHasDepartures = (attrs: Attribute[]) => {
    return attrs.length ? !isDisabled(attrs[0]) : false;
};

const showDateDetails = ref(false);

const dateToDisplay = ref<Attribute>();

const displayDate = (attr: Attribute) => {
    if (isDisabled(attr)) return;
    dateToDisplay.value = attr;
    showDateDetails.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(DateAvailability, { showAll: "" }),
      (_ctx.attributes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Click on a date for availability details"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(VCalendar), {
      "min-date": new Date(),
      locale: { id: 'en', firstDayOfWeek: 2, masks: { weekdays: 'WWW' } },
      attributes: _ctx.attributes,
      "onUpdate:pages": monthChange
    }, {
      "day-content": _withCtx(({ day, attributes }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["date-details", { 'has-departures': dateHasDepartures(attributes) }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes, (attr, i) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (displayDate(attr)),
              key: i,
              class: _normalizeClass(["availability", attr.customData ? attr.customData.class : ''])
            }, [
              (attr.customData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (!attr.customData.fitsVehicle && _ctx.hasVehicle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            class: "icon__svg"
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    (attr.customData.fitsVehicle && _ctx.hasVehicle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[2] || (_cache[2] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            class: "icon__svg"
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasCabin && attr.customData)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: _normalizeClass(["availability-rooms", attr.customData.class])
                  }, _toDisplayString(attr.customData.cabins) + " Cabins ", 3))
                : _createCommentVNode("", true)
            ], 10, _hoisted_3))
          }), 128)),
          _createElementVNode("span", null, _toDisplayString(day.day) + ".", 1)
        ], 2)
      ]),
      _: 1
    }, 8, ["min-date", "attributes"]),
    (showDateDetails.value)
      ? (_openBlock(), _createBlock(_unref(VModal), {
          key: 0,
          class: "availability-lightbox",
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showDateDetails.value = false)),
          title: dateToDisplay.value?.dates ? _unref(dateFormat)(dateToDisplay.value?.dates) : ''
        }, {
          default: _withCtx(() => [
            _createVNode(DateAvailability, {
              details: dateToDisplay.value,
              hasVehicle: _ctx.hasVehicle,
              hasCabin: _ctx.hasCabin
            }, null, 8, ["details", "hasVehicle", "hasCabin"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})